import React from 'react';

export default function FilterSeatsByArea(props) {
    return (
        <button type="button" 
                className='btn--filter booking-pathway__filters--button' 
                onClick={() => props.setSelectedArea(props.selectedArea == props.area.id ? null : props.area.id)}
                aria-selected={props.selectedArea == props.area.id}
                disabled={!props.enabledFilters.includes(props.area.id)}>
            {props.area.name}
        </button>
    );
}